import { useReducer } from "react";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import FilterComponent from "../../yoello-lib/modules/components/filterComponent/FilterComponent";
import { ICallAPIFunction } from "../../yoello-lib/modules/API2/types";
import { setFilterState } from "./state/DiscountsItems.actions"
import { DiscountsFormDialog } from "./DiscountsFormDialog";
import { setDiscountCode, setDiscountType } from "../../actions/Discounts.action";
import { DiscountsList } from "./ui/DiscountsList";
import Styles from '../../scss/discounts.module.scss';
import { OrderListHeaders } from "../orders/OrderList/OrderListViewHeaders";
import { Add } from "@material-ui/icons";
import { discountsColumns } from "./columns";
import { IDiscounts } from "../../yoello-lib/modules/interfaces/IDiscounts";
import { DiscountsReducer } from "./state/DiscountsItems.state";
import { IDiscountsItemsState } from "./types.d";
import { IDiscountType } from "../../interfaces/IDiscounts";

import { onApplyFilters } from "../menu/products/utils";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { DialogRoute } from "../dialogRoutes/DialogRoute";
import { BY_ID, CREATE_URL } from "../../const/URL.const";
import { PERMISSIONS } from "../../const/permissions.const";

import useCheckPermissions from "../../hooks/useCheckPermissions";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

interface IDiscountsItemContainer {
    discountsList: any[];
    isLoading: boolean;
    callDiscountsAPI: ICallAPIFunction<IDiscounts>;
    venueId: string;
}
const initalState: IDiscountsItemsState = {
    filterState: []
};

export function DiscountsItemContainer({
    discountsList,
    isLoading,
    callDiscountsAPI,
    venueId
}: IDiscountsItemContainer) {
    const dispatcher = useDispatch();
    const { path } = useRouteMatch();
    const history = useHistory();
    const [state, dispatch] = useReducer(
        DiscountsReducer,
        initalState
    );

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.DISCOUNT_AND_PROMOTIONS);
    
    const { t } = useTranslation();

    function createItem() {
        dispatcher(setDiscountCode(""));
        history.push(`${path}/${CREATE_URL}`, {
            dialogTitle: t('discounts.discountsContainer.create')
        })
    }
    function editItem(item: IDiscounts) {
        const newData: IDiscounts = {
            ...item,
            value: item.type === IDiscountType.VALUE ? item.value / 100 : item.value,
            minimum_order_value: item.minimum_order_value && item.minimum_order_value > 0 ? item.minimum_order_value / 100 : null
        }

        dispatcher(setDiscountType(item.type));

        history.push(`${path}/${newData.id}`, {
            itemData: newData,
            dialogTitle: t('discounts.discountsContainer.update', { discount_name: item.code }),
        })
    }
    function discountsListItems() {
        const { filterState } = state;
        if (filterState.length > 0) {
            const selectedFilters = {
                active: filterState[0].values.includes("active"),
                inActive: filterState[0].values.includes("inActive")
            }
            return onApplyFilters(discountsList, selectedFilters, getFilters())
        }
        return discountsList;
    }
    function getFilters() {
        const { filterState } = state;
        const filters: {
            key: string,
            values: string[]
        } | undefined = filterState[0];
        return [
            {
                key: "discount_status",
                label: "filters.discountStatus",
                filters: [
                    {
                        key: "active",
                        label: "filters.active",
                        param: "enabled",
                        checked: filters ? filters.values.includes("active") : false,
                        expected: true,
                    },
                    {
                        key: "inActive",
                        label: "filters.inActive",
                        param: "enabled",
                        checked: filters ? filters.values.includes("inActive") : false,
                        expected: false,
                    },
                ],
            }
        ]
    }
    function setFilters(filterSubmitData: any) {
        dispatch(setFilterState(filterSubmitData));
    }
    return <Switch>
        <Route path={path}>
            <div className={Styles.controlers}>
                <div>
                    <DisabledActionWrapper
                        disabled={!hasPermission}
                        onDisabledClick={onFailedInteraction}
                    >
                        <Button 
                            onClick={createItem}
                            size="large"
                            variant="contained"
                            color="primary"
                            data-component-name="CREATE_NEW_DISCOUNT"
                            startIcon={<Add />}
                            disabled={!hasPermission || isLoading}
                        >
                            {t('discounts.discountsContainer.create')}
                        </Button>
                    </DisabledActionWrapper>
                    
                </div>
                <span className={Styles.divider}></span>
                <div className={Styles.filter}>
                    <FilterComponent filtersList={getFilters()} filterkey={`discountsfilter-${venueId}`}
                        setFilterState={setFilters}
                    />
                </div>
            </div>
            <div data-component-name="DiscountsListContainer">
                <div key={`columnHeaders-discountsItems`} className={Styles.columnsHeader}>
                    {discountsColumns.map((column) => <OrderListHeaders {...column} key={`col-${column.key}-${column.label}`} />)}
                </div>
                <DiscountsList
                    isLoading={isLoading}
                    itemList={discountsListItems()}
                    columns={discountsColumns}
                    itemSize={70}
                    editItem={editItem}
                    emptyListTitle={t('discounts.discountsContainer.emptyList')}
                    emptyListInfo={t('discounts.discountsContainer.emptyListInfo')}
                    className={Styles.discountItems}
                />
            </div>
            <Route path={`${path}${BY_ID}`}>
                <DialogRoute
                    Component={DiscountsFormDialog}
                    ComponentPropsFunctions={{
                        callDiscountsAPI,
                    }}
                    navigateBackRoute={path}
                    dialogClassName={Styles.DiscountDialogContainer}
                    dialogTitle={{ update: t('discounts.discountsContainer.update'), create: t('discounts.discountsContainer.create') }}
                />
            </Route>

        </Route>
    </Switch>
}
